"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = __importDefault(require("axios"));
var reducers_1 = require("../reducers");
var Action_1 = require("./Redux/Action");
function CreateAxiosInstance(trackError) {
    var instance = axios_1.default.create();
    instance.interceptors.response.use(function (response) {
        return response;
    }, function (error) {
        var response = error.response;
        if (trackError) {
            var reduxStore = reducers_1.getStore();
            if (reduxStore) {
                reduxStore.dispatch(Action_1.notifyApiErrorAction(response, false, false));
                localStorage.setItem('lastApiError', JSON.stringify(response));
            }
            else {
                // eslint-disable-next-line no-console
                console.log('cannot catch api Error, redux store is not attach to component eta. Use attachReducer(store) just after the store creation.');
            }
        }
        return Promise.reject(error);
    });
    return (instance);
}
exports.CreateAxiosInstance = CreateAxiosInstance;
//# sourceMappingURL=Interceptor.js.map